import React, { Component } from 'react';
import {Grid,Cell,SelectField,Divider } from 'react-md'
import { BeatLoader } from 'react-spinners'
//import BarChart from '../components/BarChartCustom'
import LoadingSpinner from '../components/LoadingSpinner'
//import { HorizontalBar } from 'react-chartjs-2'

import {
    NotificationManager
  } from 'react-notifications';
import { AppProperties } from '../common/functions';

const loaderColor = '#bb0000';

const getCategoryAccuracyLabel = (tooltipItem, data) => {
    var label = data.datasets[tooltipItem.datasetIndex].label || '';
  
    if (label) {
        label += ': ';
    }
    label += Math.round(tooltipItem.yLabel * 100) / 100;
  
    return "Completion Accuracy :"+label;
  }

  const getCategoryAttemptLabel = (tooltipItem, data) => {
    var label = data.datasets[tooltipItem.datasetIndex].label || '';
  
    if (label) {
        label += ': ';
    }
    label += Math.round(tooltipItem.yLabel * 100) / 100;
  
    return "Attempt Time :"+label;
  }

class PerfGraphs extends Component {

    appProperties = AppProperties();

    constructor(props){
        super(props);
        this.state = {
            isCoursesLoading:true,
            hideCategoryDropDown:true,
            isCategoryLoading:false,
            isGraphLoading:false,
            hideGraphs:true,
            courses:[],
            categories:[],
            graphData:{studentCategoryAccuracy:{},studentCategoryAttemptTime:{}},
            selectedCourseID:0,
            selectedCatID:0,
            students:[],
            userName:this.props.globalProperties.currentUserData.USER_NAME,
            userRole:false,
            categoryStat:{},
            isGetGradedCategoryStatLoading:false,
            firstAttemptColor : [],
            lastAttemptColor :[],
            newCategoryNames:[],
        }
    }

    //React Event Hooks
    UNSAFE_componentWillMount(){
        this.getEnrolledCourses();
        //console.debug("this.props.globalProperties.currentUserData",this.props.globalProperties.currentUserData,"          ",this.state.userName)
        /*if(this.props.globalProperties.currentUserData.role > 0){
        this.getAllStudents();
        this.setState({userRole:true});
      }*/

    }

    //UI Event Hooks
    onCourseChange = (course) => {
      //  this.getCategoryByCourseID(course.course_id);
        this.getGradedCategoryStat(course.course_id, course.section_id);
        this.setState({selectedCourseID:course.course_id});
    }
    onStudentChange = (student) =>{
        //console.debug("selected student is",student.student_name,student.user_name)
        this.setState({userName:student.user_name});
        this.getStudentEnrolledCourses(student);
        
    }
    onCategoryChange = (category) =>{
        this.getStudentGraphs(category);
    }

    //API Calls
   /* getStudentGraphs = async(category) => {
        this.setState({isGraphLoading:true,hideGraphs:true});
        try{
            let response = await this.props.apiService({
                url:'/getStudentCatStats',
                method:'post',
                data:{
                    subjectID:category.subject_id,
                    topicID:category.topic_id,
                    categoryID:category.category_id,
                    StudentName:this.state.userName
                }
            });
            if(response && response.data){
                if(response.data.status === 0){
                    this.setState({graphData:response.data.data});
                  
                }else{
                    NotificationManager.error("error",response.data.message,5000);
                }
            }else{
                NotificationManager.error("error","Error - Empty Response",5000);
            }

        }catch(e){
            NotificationManager.error(JSON.stringify(e),"error",5000);
        }finally{
            this.setState({isGraphLoading:false,hideGraphs:false});
        }
    }*/


    getAllStudents = async () => {
        this.setState({isCoursesLoading:true,hideGraphs:true});
        console.debug("in get stuydents")
        try{
            let response = await this.props.apiService({
                url:'/getAllStudents',
                method:'post'
            });
            console.debug("data",response)
             if(response && response.data){
                 if(response.data !== undefined && response.data !== null &&
                    response.data.data !== undefined && response.data.data !== null){
                    if(response.data.status === 0){
                        this.setState({students:response.data.data});
                    
                    }else{
                        NotificationManager.error("error",response.data.message,5000);
                    }
                }else{
                    NotificationManager.error("No Student Enrolled");
                }
            }else{
                NotificationManager.error("error","Error - Empty Response",5000);
            }

        }catch(e){
            NotificationManager.error(JSON.stringify(e),"error",5000);
        }finally{
            this.setState({isCoursesLoading:false});
        }

    }

    getStudentEnrolledCourses = async (student) => {
        this.setState({isCoursesLoading:true,hideGraphs:true});
        console.debug(student.user_name)
        try{
            let response = await this.props.apiService({
                url:'/getStudentEnrolledCourses',
                method:'post',
                data:student
            });
            console.debug("respnse ",response)
            if (response.data.data === null){
                NotificationManager.error("Selected Student is not Enrolled in any Courses.");
                this.setState({
                    courses:[],
                    categories:[]
                })
            }else 
            if(response && response.data){
                if(response.data.status === 0){
                    this.setState({courses:response.data.data});
                    if(response.data.data !== null && response.data.data[0] !== undefined &&response.data.data[0] !== null ){
                        this.setState({selectedCourseID:response.data.data[0].course_id});
                        //this.getCategoryByCourseID(response.data.data[0].course_id);
                        this.getGradedCategoryStat(response.data.data[0].course_id, response.data.data[0].section_id);
                    }
                }else{
                    NotificationManager.error("error",response.data.message,5000);
                }
            }else{
                NotificationManager.error("error","Error - Empty Response",5000);
            }

        }catch(e){
            NotificationManager.error(JSON.stringify(e),"error",5000);
        }finally{
            this.setState({isCoursesLoading:false});
        }

    }

    getEnrolledCourses = async () => {
        this.setState({isCoursesLoading:true,hideGraphs:true});
        try{
            let response = await this.props.apiService({
                url:'/getEnrolledCourses',
                method:'post'
            });
            if(response && response.data){
                if(response.data.status === 0){
                    this.setState({courses:response.data.data});
                    if(response.data.data !== undefined && response.data.data !== null &&
                      response.data.data[0] !== undefined &&response.data.data[0] !== null ){
                        this.setState({selectedCourseID:response.data.data[0].course_id});
                        //this.getCategoryByCourseID(response.data.data[0].course_id);
                        this.getGradedCategoryStat(response.data.data[0].course_id, response.data.data[0].section_id);
                    }
                }else{
                    NotificationManager.error("error",response.data.message,5000);
                }
            }else{
                NotificationManager.error("error","Error - Empty Response",5000);
            }

        }catch(e){
            NotificationManager.error(JSON.stringify(e),"error",5000);
        }finally{
            this.setState({isCoursesLoading:false});
        }

    }

    /*getCategoryByCourseID = async (courseID) =>{
        this.setState({isCategoryLoading:true,hideCategoryDropDown:true});
        try{
            let response = await this.props.apiService({
                url:'/getCatByCourse',
                method:'post',
                data:{
                    courseID:courseID
                }
            });
            if(response && response.data){
                if(response.data.status === 0){
                    if(response.data.data !== null){
                        this.setState({categories:response.data.data});
                        if(response.data.data !== null && response.data.data[0] !== undefined &&response.data.data[0] !== null ){
                            this.setState({
                                selectedCatID:response.data.data[0].category_name,
                                hideCategoryDropDown:false
                            });
                            this.getStudentGraphs(response.data.data[0]);
                        }
                    }else{
                        NotificationManager.error("No Category found under this course.");                        
                    }
                }else{
                    NotificationManager.error("error",response.data.message,5000);
                }
            }else{
                NotificationManager.error("error","Error - Empty Response",5000);
            }

        }catch(e){
            NotificationManager.error(JSON.stringify(e),"error",5000);
        }finally{
            this.setState({isCategoryLoading:false});
        }
    }*/
    settingColor =  (arr) =>{
        var colorArr = []
        console.debug("arr ",arr)
        if(arr !== undefined && arr !== null){
        for(let i =0 ; i <= arr.length ; i++){
           
            if(arr[i] > 80){
                colorArr[i] = "green"
            } else if (arr[i] <= 80 && arr[i] >= 60){
                colorArr[i] ="yellow"
            } else {
                colorArr[i] ="#BB0000"
            }
            console.debug("arr ",arr[i],colorArr[i])
        }
    }
    colorArr.pop()
    console.debug(colorArr)
        return colorArr
    }

    categoryLabelvsName = (arr, arr1) => {
        var catNames = [];
        if(arr !== undefined && arr !== null && arr.length>0){
            for(let i =0 ; i < arr.length ; i++){
                if(arr1[i]!=""){
                    catNames.push(arr1[i]);
                }else{
                    catNames.push(arr[i]);
                }
            }
        }
        //console.log("categoryLabelvsName",catNames)
        return catNames;
    }


    getGradedCategoryStat = async (courseID, sectionID) =>{
        this.setState({isGetGradedCategoryStatLoading:true});
        try{
            let response = await this.props.apiService({
                url:'/getGradedCategoryStat',
                method:'post',
                data:{
                    courseID:courseID,
                    UserID:this.state.userName,
                    SectionID:sectionID
                }
            });
            if(response && response.data){
                if(response.data.status === 0){
                    let firstAttemptColor = []
                    let lastAttemptColor =[]
                    let newCategoryNames =[]
                    firstAttemptColor = this.settingColor(response.data.data.first_attempt_accuracy)
                    lastAttemptColor = this.settingColor(response.data.data.last_attempt_accuracy)
                    newCategoryNames = this.categoryLabelvsName(response.data.data.category_name, response.data.data.category_label)
                    console.debug(lastAttemptColor)
                    this.setState({
                        firstAttemptColor : firstAttemptColor,
                        lastAttemptColor : lastAttemptColor,
                        newCategoryNames: newCategoryNames,
                        categoryStat:response.data.data,
                        
                    });
                    //console.debug(firstAttemptColor,this.state.firstAttemptColor.[[PromiseValue]])
                }else{
                    NotificationManager.error("error",response.data.message,5000);
                }
            }else{
                NotificationManager.error("error","Error - Empty Response",5000);
            }

        }catch(e){
            NotificationManager.error(JSON.stringify(e),"error",5000);
        }finally{
            this.setState({isGetGradedCategoryStatLoading:false});
        }
    }
    
    render() {
       // const {studentCategoryAccuracy} = this.state.graphData;
       // const {studentCategoryAttemptTime} = this.state.graphData;
        //console.debug("students",this.state.students,this.state.userRole)
        
        return (
            <div>
               
            <Grid>
                <Cell size={12}>
                    <h1 className = "md-text--theme-primary" style = {{textAlign:'center', fontSize: 40}}>
        {this.appProperties.schoolMode?"Performance Analytics for Current Academic Year":"Performance Analytics for Current Semester"}</h1>
                </Cell>
                <Cell size={12} style={this.state.userRole ? {}:{display:"none"}}>
                    <label style={{paddingRight:"1em"}}>Student : </label>
                        
                    <CustomDropDown 
                        placeholder="Select a student"
                        id="studentName"
                        itemLabel="student_name"
                        itemValue="user_name"
                        //selectedValue={this.state.students[1].student_name}
                        data={this.state.students}
                        onChange={this.onStudentChange}
                    />
                        
                </Cell>
                <Cell size={3}>
                    <CustomDropDown 
                        placeholder="Select a Course"
                        id="enrolledCoursesDropDown"
                        itemLabel="course_name"
                        itemValue="course_id"
                        loading={this.state.isCoursesLoading}
                        data={this.state.courses}
                        onChange={this.onCourseChange}
                        selectedValue={this.state.selectedCourseID}
                    />
                </Cell>
               {/* <Cell size={3}>
                    <CustomDropDown 
                        placeholder="Select a Category"
                        id="enrolledCategoryDropDown"
                        itemLabel="category_name"
                        itemValue="category_name"
                        loading={this.state.isCategoryLoading}
                        hidden={this.state.hideCategoryDropDown}
                        data={this.state.categories}
                        onChange={this.onCategoryChange}
                        selectedValue={this.state.selectedCatID}
                    />
               </Cell>
               {this.state.hideGraphs === false ?
                    <Cell size={12} id="perf-graph-cell">
                        <Grid>
                            <Cell size={6}>
                                <BarChart showxAxesLabel={true}
                                    stepSize={1}
                                    loading={this.state.isGraphLoading} 
                                    getBarLabel={getCategoryAccuracyLabel} 
                                    graphTitleClass="graphTitleStyle"  
                                    title="Category Accuracy(%)" 
                                    data={studentCategoryAccuracy.data}  
                                    label={studentCategoryAccuracy.labels}   
                                />             
                            </Cell>
                            <Cell size={6}>
                                <BarChart 
                                    loading={this.state.isGraphLoading} 
                                    graphTitleClass="graphTitleStyle"  
                                    getBarLabel={getCategoryAttemptLabel} 
                                    title="Category Attempt Time(in seconds)" 
                                    showxAxesLabel={true} 
                                    stepSize={1} 
                                    data={studentCategoryAttemptTime.data}  
                                    label={studentCategoryAttemptTime.labels}   
                                /> 
                            </Cell>
                        </Grid>
                    </Cell>
                : ""*/}
                {(this.state.isGetGradedCategoryStatLoading) ? 
                    <LoadingSpinner /> :
                    <div style={{width:"100%",height: "100%"}}>                                            
                        {this.state.categoryStat !== undefined && this.state.categoryStat !== null  ? 
                        <div>
                            <Grid>
                            <Cell size={12}>
                                <p  style={{fontSize: "medium"}}>Attempt Accuracy(% Correct)</p>
                                <Divider className="fullWidth" />
                                <div style={{height:"400px",width:"90%"}}>
                                        <CustomDualHorizontalBar 
                                        color={this.state.firstAttemptColor} 
                                        color1={this.state.lastAttemptColor} 
                                        isLabel={true} 
                                        label={this.state.newCategoryNames} 
                                        data = {this.state.categoryStat.first_attempt_accuracy}
                                        data2={this.state.categoryStat.last_attempt_accuracy}
                                        label1={"First Attempt Accuracy"}
                                        label2={"Last Attempt Accuracy"}
                                        stepSize={20}
                                        />
                                </div>
                            </Cell>
                            <Cell size={12}>
                                <p  style={{fontSize: "medium"}}>Attempt Time(Seconds)</p>
                                <Divider className="fullWidth" />
                                <div style={{height:"400px",width:"90%"}}>
                                        <CustomDualHorizontalBar 
                                        color={"#1B75BC"} 
                                        color1={"#FC91AD"} 
                                        isLabel={true} 
                                        label={this.state.categoryStat.category_name} 
                                        data = {this.state.categoryStat.first_attempt_time}
                                        data2={this.state.categoryStat.last_attempt_time}
                                        label1={"First Attempt Time"}
                                        label2={"Last Attempt Time"}
                                        stepSize={0}
                               />
                                        
                                </div>
                            </Cell>
                            </Grid >
                        </div>
                        : ''}
                    </div>
                } 
                </Grid>
            </div>
        );
    }
}




const CustomDropDown =(props) =>{

    const onChange = (_, index) => {
        props.onChange(props.data[index],index);
    }

    if(props.loading){
        return <BeatLoader loading={true} color={loaderColor}/>
    }

    if(props.hidden){
        return null;
    }
    if(props.data === undefined || props.data === null || props.data.length === 0){
        return null;
    }
    return <SelectField
                id={props.id}
                itemLabel={props.itemLabel}
                itemValue={props.itemValue}
                placeholder={props.placeholder}
                menuItems={props.data}
                onChange={onChange}
                value={props.selectedValue}
            />
}

const CustomDualHorizontalBar =(props) =>{
    const   dualHorizontalBarsChartData = { 
        labels: props.label,
        datasets: [ 
            { 
                label: props.label1,
                backgroundColor: props.color,
                data:props.data,
                borderWidth: 0,
            },{
                label: props.label2,
                backgroundColor: props.color1,
                data:props.data2,
                borderWidth: 0,
            }
        ]
    }
        const dualChartOptions = { 
            responsive: true ,
            maintainAspectRatio:false,
            barPercentage: 1,
            legend: {
              display: false
            },
            scales: {
              xAxes: [
                {
                  ticks:{
                      min: 0,
                      stepSize:props.stepSize
                  }
                }
              ],
              yAxes: [
                {
                    display: props.isLabel
                }
              ]
            }
          }
       
    return null //<HorizontalBar data={dualHorizontalBarsChartData} options={dualChartOptions} />
                                    
}
    

export default PerfGraphs;